import staffAiConversationsAPI from '../../../api/nexceo/staffAiConversations';

const state = {
  conversations: [],
  loading: false,
  error: null,
};

const getters = {
  allConversations: s => s.conversations,
  loading: s => s.loading,
  error: s => s.error,
  byId: s => id => s.conversations.find(c => c.id === id),
};

const mutations = {
  SET_LOADING(s, val) {
    s.loading = val;
  },
  SET_ERROR(s, err) {
    s.error = err;
  },
  SET_CONVERSATIONS(s, list) {
    s.conversations = list;
  },
};

const actions = {
  fetchConversations: async ({ commit }, params = {}) => {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const { data } = await staffAiConversationsAPI.getAll(params);
      commit('SET_CONVERSATIONS', data.staff_ai_conversations || []);
    } catch (err) {
      commit(
        'SET_ERROR',
        err?.response?.data?.error || 'Failed to load staff AI conversations.'
      );
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
